import { render, staticRenderFns } from "./teamStaff.vue?vue&type=template&id=6a4790b0"
import script from "./teamStaff.vue?vue&type=script&lang=js"
export * from "./teamStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports